"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cotDocs = void 0;
var cotDocs = exports.cotDocs = {
  name: 'cot',
  category: 'Trigonometry',
  syntax: ['cot(x)'],
  description: 'Compute the cotangent of x in radians. Defined as 1/tan(x)',
  examples: ['cot(2)', '1 / tan(2)'],
  seealso: ['sec', 'csc', 'tan']
};